import React, { useEffect, useRef, useState, useCallback } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { FaHourglassHalf } from "react-icons/fa";
import { RiShareFill } from "react-icons/ri";
import { BiMessageDetail } from "react-icons/bi";
import { PiPhoneCallFill } from "react-icons/pi";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import { MdWork } from "react-icons/md";
import { BsDot } from "react-icons/bs";
import { IoLocationSharp } from "react-icons/io5";
import axiosInstance, { Razorpay_Key } from "../../Services/axios";

import defaultperson from "../../Assets/Images/defaultperson.jpg";
import { IoIosStarOutline } from "react-icons/io";
import { IoMdStar } from "react-icons/io";
import { useUser } from "../../Components/UserContext";
import { getDatabase, ref, onValue } from "firebase/database";
import VerticalStepper from "../../Components/stepper";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "react-loading";
import { toast } from "react-toastify";
import useRazorpay from "react-razorpay";
import { IoMdClose } from "react-icons/io";
import tick_icon from "../../Assets/Images/icons/tick_icon.png"
import live_tracking_lens from "../../Assets/Images/icons/live_tracking_lens.png"
import AppointmentCancelled from "../../Assets/Images/Appointment.jpg";
import NodeaxiosInstance from "../../Services/nodeaxios";
import store_icon from "../../Assets/Images/icons/store_icon.png"
import { FaLocationArrow } from "react-icons/fa";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import Kitchen_membership_card from "../../Components/KitchenMembershipCard/Kitchen_membership_card";
import { useSelector } from "react-redux";
import Kitchen_ticket from "../../Components/kichen_tickct/kitchen_ticket";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DownLossdbillingPDF from "../../Components/downloadBillingPDF";
import KitchenMembershipdetailCard from "../../Components/KitchenMembershipCard/KitchenMembershipdetailCard";
import KitchenMembershiplistCard from "../../Components/KitchenMembershipCard/KitchenMembershiplistCard";
import KitchenProductTicket from "../../Components/kichen_tickct/kitchenProductTicket";
import KitchenComboTicket from "../../Components/kichen_tickct/kitchenComboTicket";
import { showToast } from "../../Components/toastConfig/ToastConfig";

// same unit ids as the mobile app
const MEMBERSHIP_PRODUCT_UNITS = { 1: "Grams", 2: "Kg", 3: "Ml", 4: "Liters", 5: "Pieces" };

function Kitchen_OrderPass() {

    const valueParam = useParams();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);

    const order_id = valueParam.order_id;

    const [Razorpay] = useRazorpay();
    const currentUser = useUser(); // Access user context
    const locations = useLocation();
    const { fromPage } = locations.state || {};

    const navigate = useNavigate();
    const canceldisputeModalRef = useRef(null);
    const cancelConfirmModalRef = useRef(null);
    const cancelRefundModalRef = useRef(null)
    const cancelOrderConfirmModalRef = useRef(null)

    const [record, setRecord] = useState('')
    const [showContent, setShowContent] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [showStaffDetails, setShowStaffDetails] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const DEFAULT_Ticket_IMAGE_URL = "https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/FoodPlaceholderRect.png";
    const DEFAULT_IMAGE_URL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";

    const [staff, setStaff] = useState([]);
    const [vendor, setVendor] = useState('');
    const [cancelorder, setCancelorder] = useState([]);
    const [refund, setRefund] = useState([]);
    const [ratecount, setRatecount] = useState('');
    const [feedback, setFeedback] = useState('');
    const [ratings, setRatings] = useState([false, false, false, false, false]);
    const [copied, setCopied] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [dispute, setDispute] = useState('')
    const [pilotRatecount, setPilotRatecount] = useState('');
    const [delivery_partner_feedback, setDelivery_partner_feedback] = useState('');
    const [pilotratings, setPilotRatings] = useState([false, false, false, false, false]);
    const [distance, setDistance] = useState('')
    const [data, setData] = useState();


    const [isModalOpen, setIsModalOpen] = useState(false)
    const [ticket_tab, setTicket_tab] = useState(1)
    const [editproductRateing, setEditProductRateing] = useState(false)
    const [editdeliveryRateing, setEditDeliveryRateing] = useState(false)
    const [isLoading, setIsloading] = useState(false)
    const [timeLeft, setTimeLeft] = useState("00:00:00");

    useEffect(() => {
        if (!currentUser) return;
        const database = getDatabase();
        const orderRef = ref(database, `/orders/${order_id}`);
        const unsubscribe = onValue(orderRef, (snapshot) => {
            let data = snapshot.val();
            if (data) {
                getorderDetails();
            }
        });

        return () => unsubscribe();
    }, [currentUser, order_id]);



    useEffect(() => {
        getorderDetails();
    }, [order_id]);



    const handleStarClick = (index) => {
        const newRatings = [...ratings];
        for (let i = 0; i < newRatings.length; i++) {
            if (i <= index) {
                newRatings[i] = true;
            } else {
                newRatings[i] = false;
            }
        }
        setRatings(newRatings);
        setRatecount(index + 1);
    };

    const handlePiltoStarClick = (index) => {
        const pilotnewRatings = [...ratings];
        for (let i = 0; i < pilotnewRatings.length; i++) {
            if (i <= index) {
                pilotnewRatings[i] = true;
            } else {
                pilotnewRatings[i] = false;
            }
        }
        setPilotRatings(pilotnewRatings);
        setPilotRatecount(index + 1);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const toggleStaffDetails = () => {
        setShowStaffDetails(!showStaffDetails);
    };

    const toggleContent = () => {
        setShowContent(!showContent);
    };

    const getorderDetails = () => {
        try {
            NodeaxiosInstance
                .get("/kitchen/order", {
                    params: {
                        order_id: order_id
                    },
                    headers: {
                        Authorization: userData?.token
                    }
                })
                .then((res) => {
                    let data = res.data;
                    setRecord(data.order_detail);

                    const hubLat = data?.order_detail?.hub_lat;
                    const hubLng = data?.order_detail?.hub_long;

                    const tryGetDistance = (originLat, originLng) => {
                        if (originLat && originLng && hubLat && hubLng) {
                            fetchHubDirection(`${originLat},${originLng}`, `${hubLat},${hubLng}`);
                        }
                    };

                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                tryGetDistance(position.coords.latitude, position.coords.longitude);
                            },
                            (error) => {
                                console.log("Geolocation error/denied:", error);
                                const deliveryLat = data?.order_detail?.delivery_address?.lat || data?.order_detail?.delivery_address?.latitude;
                                const deliveryLng = data?.order_detail?.delivery_address?.long || data?.order_detail?.delivery_address?.lng || data?.order_detail?.delivery_address?.longitude;
                                tryGetDistance(deliveryLat, deliveryLng);
                            }
                        );
                    } else {
                        const deliveryLat = data?.order_detail?.delivery_address?.lat || data?.order_detail?.delivery_address?.latitude;
                        const deliveryLng = data?.order_detail?.delivery_address?.long || data?.order_detail?.delivery_address?.lng || data?.order_detail?.delivery_address?.longitude;
                        tryGetDistance(deliveryLat, deliveryLng);
                    }

                    if (data?.order_detail?.order_type == 2) {
                        fetch_ticket_deta(data?.order_detail?.ticket_id)
                    }

                }).catch((err) => {
                    // if (err.response.status == 400 || err.response.status == 500) {
                    //   toast(err.response.data.message, {
                    //     position: "bottom-center",
                    //     autoClose: 5000,
                    //     hideProgressBar: true,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "light",
                    //     className: "text-danger toast-style-1",
                    //   });
                    // }
                    // showToast("Something went wrong. Please try again later.") 
                });
        } catch (error) {
            showToast("Something went wrong. Please try again later.")

        } finally {
            setTimeout(() => {
                setPageLoaded(true);

            }, 600);
        }
    };



    const fetch_ticket_deta = async (ticket_id) => {
        try {
            const headers = { Authorization: userData?.token };

            const response = await NodeaxiosInstance.get(`kitchen/single-membership-booking`, {
                params: {
                    booking_id: ticket_id,
                },
                headers,
            });

            if (response.status == 200) {
                setData(response.data?.booking_detail)
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error fetching ticket details:", error);
            showToast("Something went wrong. Please try again later.")

        }
    };

    const openCancel_modal = () => {
        cancelRefundModalRef.current.classList.add("show");
        cancelRefundModalRef.current.style.display = "block";
        setIsModalOpen(true)
    }

    const getrefund = () => {
        try {
            NodeaxiosInstance
                .get("/kitchen/refund-info", {
                    params: {
                        order_id: order_id
                    },
                    headers: {
                        Authorization: userData?.token
                    }
                })
                .then((res) => {


                    setRefund(res.data.refund_message);
                    openCancel_modal()
                }).catch((err) => {
                    if (err.response.status === 400 || err.response.status === 500) {

                        toast(err.response.data.message, {
                            position: "bottom-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: "text-danger toast-style-1",
                        });
                    }
                });
        } catch (error) {
            showToast("Something went wrong. Please try again later.")

        }
    };

    const cancel_order = async () => {
        try {
            setLoading(true); // Start loading
            setButtonClicked(true);
            setIsloading(true);

            let reqData = {
                order_id: order_id,
            };

            NodeaxiosInstance.post("/kitchen/cancel-order", reqData, {
                headers: {
                    Authorization: userData?.token
                }
            }).then((res) => {


                setIsloading(false);
                cancelRefundModalRef.current.classList.remove("show");
                cancelRefundModalRef.current.style.display = "none";
                cancelConfirmModalRef.current.classList.add("show");
                cancelConfirmModalRef.current.style.display = "block";

                closecancelOrderModal();
            });

        } catch (error) {
            showToast("Something went wrong. Please try again later.")

        }
    };



    const Order_rating = () => {
        try {
            let reqData = {
                order_id: order_id,
                rating: ratecount,
                review: feedback,
            };

            NodeaxiosInstance.post("/kitchen/rate-order", reqData)
                .then((res) => {
                    setEditProductRateing(false)
                    toast("Rating has been submitted.", {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: "text-success toast-style-1",
                    });
                })
                .catch((err) => {

                    let errorMessage = 'An unexpected error occurred';
                    if (err.response) {

                        switch (err.response.status) {
                            case 400:
                                errorMessage = 'Rating Count field is required';
                                break;
                            case 500:
                                errorMessage = 'Feedback is required';
                                break;
                            default:
                                errorMessage = ` ${err.response.data.message || 'Unknown error'}`;
                                break;
                        }
                    } else if (err.request) {
                        // The request was made but no response was received
                        errorMessage = 'No response was received from the server';
                    } else {
                        // Something happened in setting up the request that triggered an error
                        errorMessage = 'An error occurred: ' + err.message;
                    }

                    toast(errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: "text-danger toast-style-1", // Use a different class or styling for error messages
                    });
                });
        }
        catch (error) {
            showToast("Something went wrong. Please try again later.")

        }
    }

    const delivery_Partner_rateing = () => {
        try {
            let reqData = {
                order_id: order_id,
                rating: pilotRatecount,
                review: delivery_partner_feedback,
            };
            if (record.rating_status) {
                reqData["rate_id"] = order_id;
            }
            NodeaxiosInstance.post("/kitchen/rate-pilot", reqData)
                .then((res) => {
                    setEditDeliveryRateing(false)
                    toast("Rating has been submitted.", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: "text-success toast-style-1",
                    });
                })
                .catch((err) => {
                    let errorMessage = 'An unexpected error occurred';
                    if (err.response) {

                        switch (err.response.status) {
                            case 400:
                                errorMessage = 'Rating Count field is required';
                                break;
                            case 500:
                                errorMessage = 'Feedback is required';
                                break;
                            default:
                                errorMessage = ` ${err.response.data.message || 'Unknown error'}`;
                                break;
                        }
                    } else if (err.request) {
                        errorMessage = 'No response was received from the server';
                    } else {
                        errorMessage = 'An error occurred: ' + err.message;
                    }

                    toast(errorMessage, {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: "text-danger toast-style-1", // Use a different class or styling for error messages
                    });
                });
        }
        catch (error) {
            showToast("Something went wrong. Please try again later.")

        }
    }


    useEffect(() => {
        if (!record) return;

        let targetTime;

        // ✅ If skip_status true → 1 hour from now
        if (record.skip_status === true) {
            targetTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour
        } else {
            // ✅ Otherwise use backend skip_before
            targetTime = new Date(record.skip_before).getTime();
        }

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const diff = targetTime - now;

            if (diff <= 0) {
                clearInterval(interval);
                setTimeLeft("00:00:00");
                return;
            }

            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setTimeLeft(
                `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
                    2,
                    "0"
                )}:${String(seconds).padStart(2, "0")}`
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [record]);

    const closecancelOrderModal = () => {
        cancelOrderConfirmModalRef.current.classList.remove("show");
        cancelOrderConfirmModalRef.current.style.display = "none";

    };

    const copyToClipboard = () => {
        const hubSlug = record?.hub_name
            ?.trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
        const textToCopy = hubSlug ? `link.pingle.in/${hubSlug}` : vendor.vendor_share_link;
        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(textarea);
        setCopied(true);

        toast("Link copied!", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: "text-dark toast-style-1",
        });

        // Reset the copied state after 2 seconds
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const skipMemberShip = async () => {
        try {
            NodeaxiosInstance
                .get("/kitchen/skip-membership", {
                    params: {
                        order_id: order_id
                    },
                    headers: {
                        Authorization: userData?.token
                    }
                })
                .then((res) => {
                    getorderDetails()
                }).catch((err) => {
                    if (err.response.status === 400 || err.response.status === 500) {

                        toast(err.response.data.message, {
                            position: "bottom-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: "text-danger toast-style-1",
                        });
                    }
                });
        } catch (error) {
            showToast("Something went wrong. Please try again later.")

        }
    }

    const formattedDate = new Date(record?.created_date).toLocaleDateString(
        "en-US",
        {
            weekday: "short",
            month: "long",
            day: "2-digit",
            year: "numeric",
        }
    );
    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const formatted = date.toLocaleString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

        return formatted.replace(",", ""); // remove comma after day
    };
    const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
        if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) return null;
        const R = 6371; // km
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return `${d.toFixed(1)} km`;
    };

    const fetchHubDirection = async (origin, destination) => {
        try {
            console.log('origin, destination---', origin, destination);

            if (origin && destination) {
                const [lat1, lon1] = origin.split(',').map(Number);
                const [lat2, lon2] = destination.split(',').map(Number);
                const haversineDist = calculateHaversineDistance(lat1, lon1, lat2, lon2);
                if (haversineDist) {
                    setDistance({ text: haversineDist, value: 0 });
                }
            }

            const response = await axios.get(
                'https://maps.googleapis.com/maps/api/directions/json', {
                params: {
                    origin: origin,
                    destination: destination,
                    mode: 'driving',
                    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_TEST_API_KEY,
                },
                headers: {
                    Accept: 'application/json',
                },
            }
            );

            if (response?.data?.routes?.[0]?.legs?.[0]?.distance) {
                const leg = response.data.routes[0].legs[0];
                setDistance(leg.distance);
            }

        } catch (error) {
            console.error('calculateDistance | Error:', error);
        }
    };


    return (
        <div>
            <div className="min-vh-100">
                <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                    <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                        <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => {
                            fromPage == "DashBoard" ? navigate("/dashboard") : fromPage == "ReviewPay" ?
                                navigate("/", { state: { fromPage: "ProductPass" } }) : fromPage == "transaction" ? navigate(-1) : navigate("/", { state: { fromPage: "ProductPass" } });
                        }} />
                        <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                            Ticket pass
                        </div>
                    </div>
                </div>

                {pageLoaded ?
                    <div className="p-3 scroller-style-y">
                        <div className="servicePassCard">
                            <div className="">
                                <div class="TicketPass-Div">
                                    {
                                        record.shipping_type == "2" ?
                                            <div className="w3-bar w3-black d-flex justify-content-center w-100">
                                                <div class="Switch-T-S nav flex-column nav-pills me-3" id="v-pills-tab"
                                                    role="tablist" aria-orientation="vertical" className="d-flex justify-content-between"  >
                                                    <div className="col-6" onClick={() => setTicket_tab('1')}>
                                                        <button class={`px-5 nav-link   w-100 ff-poppins-semiBold w3-bar-item w3-button ${ticket_tab == 1 ? " active" : ""}`}
                                                            id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home"
                                                            type="button" role="tab" aria-controls="v-pills-home" aria-selected="true"  >
                                                            Ticket
                                                        </button>
                                                    </div>
                                                    <div className="col-6" onClick={() => setTicket_tab('2')}>
                                                        <button class={`px-5 nav-link   w-100 ff-poppins-semiBold w3-bar-item w3-button ${ticket_tab == 2 ? " active" : ""}`}
                                                            style={{ paddingRight: 40, paddingLeft: 40 }} id="v-pills-profile-tab" data-bs-toggle="pill"
                                                            data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" >
                                                            Schedule
                                                        </button>
                                                    </div>
                                                </div>
                                            </div> : ""
                                    }

                                    <div class="tab-content col-12" id="v-pills-tabContent">
                                        {
                                            ticket_tab == 1 ?
                                                <div className={`tab-pane  ${ticket_tab == 1 ? "show active" : "fade"} `} >
                                                    {record.order_status == 2 || record.delivery_status == 5 ? (
                                                        <div className="p-2">

                                                            {editdeliveryRateing ?

                                                                <div className="feedback_box p-3" >
                                                                    <div className=" text-center">
                                                                        <h6 className="p-0 m-0 ff-poppins-medium primary-text" >Rate the delivery partner</h6>
                                                                        <p className="p-0 m-0 ff-poppins-medium fs-10" >Rate the delivery experience!</p>
                                                                    </div>
                                                                    <div className="feedback mt-1 mb-1">
                                                                        {pilotratings.map((filled, index) => (
                                                                            <div key={index} onClick={() => handlePiltoStarClick(index)}>
                                                                                {filled ? <IoMdStar color="gold" size={30} /> : <IoIosStarOutline color="gold" size={30} />}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <fieldset className="feedbackInput rounded-3 secondary-border" >
                                                                        <input className="feedbackEnter bg-white fs-12 text-darl ff-poppins-medium" value={delivery_partner_feedback} onChange={(e) => setDelivery_partner_feedback(e.target.value)} type="text" />
                                                                        <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => delivery_Partner_rateing()}  >
                                                                            POST
                                                                        </button>
                                                                    </fieldset>
                                                                </div> :
                                                                <div className="rounded-3 secondary-border mt-2">
                                                                    <div className="p-3">
                                                                        <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Delivery Rating and Review</h6>
                                                                        <div className="d-flex justify-content-between mt-1">
                                                                            <div className="delivery_star d-flex">
                                                                                {pilotratings.map((filled, index) => (
                                                                                    <div key={index} onClick={() => handleStarClick(index)} className="fs-14" >
                                                                                        {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <div className="rounded-2 align-self-center text-dark secondary-border text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditDeliveryRateing(true)} >
                                                                                Edit
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            feedback ?
                                                                                <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text">{delivery_partner_feedback} </h6> :
                                                                                <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text">Please give your feedback</h6>
                                                                        }
                                                                    </div>
                                                                </div>

                                                            }

                                                            {editproductRateing ?
                                                                <div className="feedback_box p-3" >
                                                                    <div className=" text-center">
                                                                        <h6 className="p-0 m-0 ff-poppins-medium primary-text" >Rate the product</h6>
                                                                        <p className="p-0 m-0 ff-poppins-medium fs-10" >Rate the record.experience!</p>
                                                                    </div>
                                                                    <div className="feedback mt-1 mb-1">
                                                                        {ratings.map((filled, index) => (
                                                                            <div key={index} onClick={() => handleStarClick(index)}>
                                                                                {filled ? <IoMdStar color="gold" size={30} /> : <IoIosStarOutline color="gold" size={30} />}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <fieldset className="feedbackInput rounded-3 secondary-border ">
                                                                        <input className="feedbackEnter bg-white fs-12 text-darl ff-poppins-medium" value={feedback} onChange={(e) => setFeedback(e.target.value)} type="text" />
                                                                        <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => Order_rating()}  >
                                                                            POST
                                                                        </button>
                                                                    </fieldset>
                                                                </div> :
                                                                <div className="rounded-3 secondary-border mt-2">
                                                                    <div className="p-3">
                                                                        <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Product Rating and Review</h6>
                                                                        <div className="d-flex justify-content-between mt-1 mb-1">
                                                                            <div className="delivery_star d-flex">
                                                                                {ratings.map((filled, index) => (
                                                                                    <div key={index} onClick={() => handleStarClick(index)} className="fs-14" >
                                                                                        {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <div className="rounded-2 align-self-center secondary-border text-dark text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditProductRateing(true)}>
                                                                                Edit
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            feedback ?
                                                                                <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text">{feedback} </h6> :
                                                                                <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text">Please provide your feedback</h6>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }


                                                        </div>
                                                    ) : (
                                                        <div className="tab-pane fade show active p-0" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabIndex="0">
                                                            {/* no QR for a cancelled order */}
                                                            {record.order_status != 3 && (
                                                                <div className="d-flex justify-content-center mt-2">
                                                                    <img src={record.order_qr} height="60%" width="60%" />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div> :
                                                ticket_tab == 2 ?
                                                    <div className={`tab-pane  ${ticket_tab == 2 ? "show active" : "fade"} `}  >
                                                        <div className="stepper-Box p-3" >
                                                            {
                                                                record.delivery_staff_status != true && record.order_status != 3 &&
                                                                <div className="">
                                                                    <div className="secondary-box  w-100 rounded-3">
                                                                        <div className="p-2 d-flex justify-content-between">

                                                                            <div>
                                                                                <h6 className="p-0 m-0 ff-poppins-medium primary-text fs-14" >Order Placed</h6>
                                                                                <p className="p-0 m-0 ff-poppins-regular fs-11">Food preparation will begin shortly.</p>
                                                                            </div>
                                                                            <div>
                                                                                <img src={tick_icon} height="20px" width="20px" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="secondary-box  w-100 rounded-3 mt-2">
                                                                        <div className="p-2 d-flex justify-content-between">
                                                                            <div>
                                                                                <h6 className="p-0 m-0 ff-poppins-medium primary-text fs-14" >
                                                                                    {
                                                                                        record.delivery_staff_status == true ? "Delivery Staff Assigned."
                                                                                            : "Assigning Your Delivery Staff Soon"
                                                                                    }
                                                                                </h6>
                                                                                <p className="p-0 m-0 ff-poppins-regular fs-11">
                                                                                    {
                                                                                        record.delivery_staff_status == true ? " Your order is now assigned for delivery." :
                                                                                            " Expect a delivery staff assignment shortly."
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                            {
                                                                                record.delivery_staff_status == true ?
                                                                                    <div>
                                                                                        <img src={tick_icon} height="20px" width="20px" />
                                                                                    </div> :
                                                                                    record.order_type == "INSTANT" &&
                                                                                    <div class="spinner-border mt-1 primary-text" role="status" style={{ height: "25px", width: "25px" }} >
                                                                                        <span class="visually-hidden">Loading...</span>
                                                                                    </div>
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            }

                                                            {

                                                                record.delivery_steps_detail.length > 0 && (record.delivery_staff_status == true || record.order_status == 3) && (
                                                                    <div>
                                                                        <VerticalStepper steps={record.delivery_steps_detail} />

                                                                        {/* {record.order_status != 3 && */}
                                                                        {/* <div className="d-flex justify-content-end" onClick={() => navigate(`/live_traking/${order_id}`)} >
                                                                        <div className="primary-bg col-5 rounded-2 d-flex justify-content-center align-items-center" style={{ height: "32px" }}>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <img src={live_tracking_lens} height="12px" width="12px" />

                                                                                <div className="text-light fs-12 ff-poppins-regular ms-2">
                                                                                    Live Tracking
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                        {/* } */}
                                                                    </div>
                                                                )}


                                                        </div>
                                                    </div>
                                                    : ""
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div>
                                <div className="servicePassCard">
                                    <div>
                                        <div className="headerDivPP d-flex">
                                            <div className="col-8  ">
                                                <p className="m-0 fs-13 ff-poppins-semiBold">
                                                    {formatDateTime(record.order_date)} - {record?.meal_time_lable}
                                                </p>
                                                <p className=" fs-13 m-0 ff-poppins-semiBold">
                                                    Order id - <span>{record.order_id} </span>
                                                </p>
                                            </div>
                                            {record.order_status == 3 ? (
                                                <div>
                                                    <button className="unpaidbtn fs-14 p-1 ff-poppins-semiBold">Cancelled</button>
                                                </div>
                                            ) : (
                                                <div className="d-flex">
                                                    <div className="d-flex flex-column align-items-center otpBorderProuductDiv">
                                                        <div className="otpBorderProuduct"></div>
                                                    </div>
                                                    <div className="me-2">
                                                        <p className="m-0 fs-13 ff-poppins-semiBold">
                                                            <b>OTP:</b>
                                                        </p>
                                                        <p className="bookIdSP fs-13 m-0 ff-poppins-semiBold">
                                                            {record.order_code}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {record.shipping_type == "2" ? (
                                        <div>
                                            <h6 className="  m-0 mb-2 mt-1 fs-14 mb-0 ff-poppins-semiBold">
                                                Delivery Address
                                            </h6>
                                            <div className="addresHeadDivPP">
                                                <div className="addressHomeDivPP">
                                                    <div className="homeIConDivPP">
                                                        {record?.delivery_address?.location_type_id == 1 ? (
                                                            <IoMdHome className="homeIconPP" />
                                                        ) : record?.delivery_address?.location_type_id == 2 ? (
                                                            <MdWork className="homeIconPP" />
                                                        ) : record?.delivery_address?.location_type_id == 3 ? (
                                                            <IoLocationSharp className="homeIconPP" />
                                                        ) : (
                                                            <p>No Icon</p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="addTextDivPP">
                                                    <h6 className="ff-poppins-semiBold fs-13 m-0">
                                                        <b>{record?.delivery_address?.location_type} </b>
                                                    </h6>
                                                    <h6 className="addressTextPP fs-12 m-0 ff-poppins-regular numberOfLines">
                                                        {record?.delivery_address?.address}
                                                    </h6>
                                                    <h6 className="addressTextPP fs-12 m-0 ff-poppins-regular">
                                                        {`${(record?.delivery_address?.distance?.text || "").substring(0, 10)}-${(record?.delivery_address?.duration?.text || "").substring(0, 10)}`}
                                                    </h6>
                                                </div>
                                                <div className="arrowDivPP">
                                                    <IoIosArrowForward />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {
                                        record?.order_type == 1 ?

                                            <>
                                                <h6 className="ff-poppins-semiBold fs-14  m-0 py-2">Food Ticket</h6>
                                                {/* <Kitchen_ticket Data={record} fromPage={'orderPass'} /> */}
                                                {/* <KitchenProductTicket /> */}
                                                {
                                                    record?.ticket?.ticket_combo ?
                                                        <KitchenComboTicket item={record?.ticket} fromPage={'OrderPass'} /> :
                                                        record?.ticket?.ticket_product ?
                                                            <KitchenProductTicket item={record?.ticket} fromPage={'OrderPass'} /> : ''

                                                }
                                            </> : record?.order_type == 2 ?
                                                <>
                                                    <h6 className="ff-poppins-semiBold fs-14  m-0 py-2">Membership Ticket</h6>
                                                    <KitchenMembershiplistCard item={{ ...record?.ticket, vendor_id: record?.hub_id }} hideAction />
                                                    {(() => {
                                                        const menu = record?.ticket?.membership_menu;
                                                        const products = (menu?.products?.length > 0 ? menu.products : (menu?.combo?.products || [])).filter(Boolean);
                                                        if (products.length === 0) return null;
                                                        return (
                                                            <div className="mt-3">
                                                                <h6 className="ff-poppins-semiBold fs-14 m-0 py-2">
                                                                    {menu?.meal_type ? `${menu.meal_type} ` : ""}{products.length > 1 ? "Products" : "Product"}
                                                                </h6>
                                                                {products.map((item, index) => (
                                                                    <div className="d-flex secondary-box p-2 mt-2 rounded-3" key={item?.kitchen_product_id ?? index}>
                                                                        <div>
                                                                            <img src={item?.product_image ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.product_image}` : DEFAULT_Ticket_IMAGE_URL}
                                                                                onError={(e) => (e.currentTarget.src = DEFAULT_Ticket_IMAGE_URL)}
                                                                                height="80px" width="80px" className="rounded-3" alt="" />
                                                                        </div>
                                                                        <div className="ms-3">
                                                                            <p className="p-0 m-0 mt-1 fs-13 ff-poppins-medium">{item?.product_name}</p>
                                                                            <div className="d-flex align-items-center">
                                                                                {item?.food_type && item?.food_type != 0 &&
                                                                                    <img src={item?.food_type == "1" ? vegIcon : item?.food_type == "2" ? nonvegIcon : item?.food_type == "3" ? eggIcon : ""}
                                                                                        height="13px" width="13px" className="me-1" alt="" />}
                                                                                <p className="p-0 m-0 fs-12 primary-text ff-poppins-medium">{item?.category_name}</p>
                                                                            </div>
                                                                            {item?.product_quantity_value != null && item?.product_quantity_value !== '' && (
                                                                                <p className="p-0 m-0 fs-11 primary-text ff-poppins-regular">
                                                                                    Quantity: {item.product_quantity_value} {MEMBERSHIP_PRODUCT_UNITS[Number(item.product_quantity)] || ""}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        );
                                                    })()}
                                                    {(record?.ticket?.carrier_selected == 1 || data?.carrier_selected == 1) && (
                                                        <div className="mt-3">
                                                            <h6 className="ff-poppins-semiBold p-0 m-0">Carrier Option</h6>
                                                            <div
                                                                className="d-flex justify-content-between align-items-center border rounded p-2 mt-2"
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <input type="checkbox" className="form-check-input m-0 me-2" checked readOnly />
                                                                    <div>
                                                                        <p className="m-0 ff-poppins-medium fs-13">Tiffin carrier</p>
                                                                        <p className="m-0 fs-11 ff-poppins-regular secondary-text">One time charge added to your bill</p>
                                                                    </div>
                                                                </div>
                                                                <span className="ff-poppins-semiBold fs-13">
                                                                    ₹{record?.ticket?.carrier_booking_charge ?? data?.carrier_booking_charge}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                                : ""
                                    }
                                    {
                                        record?.skip_status == true &&
                                        <div className="membershipDailyConfirmationBox">
                                            <div className="membershipConfirmationTimerBox " >
                                                <span>Time left till daily confirmation</span> <br></br>
                                                <span>{timeLeft}</span>
                                            </div>

                                            <div className="d-flex justify-content-center">

                                                <button className="membershipConfirmationTimerBtn">Skip</button>
                                            </div>
                                        </div>
                                    }


                                    {/* 
                                <div className="bonusProductCard mt-3 d-flex">
                                    <div>
                                        <img
                                            src="https://cdn.zeptonow.com/production/tr:w-312,ar-1200-1200,pr-true,f-auto,q-40/cms/product_variant/9e0cde5d-4bc6-4cf1-a25b-fdc14b00e7de.jpeg"
                                            className="bonusProductImg"
                                        />
                                    </div>

                                    <div className="d-flex flex-column flex-grow-1 ms-2">
                                        <div className="d-flex justify-content-start">
                                            <div>
                                                <span className="d-flex align-items-center fs-14 ff-poppins-semiBold">
                                                    <img
                                                        src={nonvegIcon}
                                                        height="13px"
                                                        width="13px"
                                                        className="me-1"
                                                    />
                                                    Budweiser
                                                </span>
                                                <span className="fs-12 ff-poppins-semiBold">(120ml)</span>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end mt-auto">
                                            <div>
                                                <span className="bonusProductLeftCount ">
                                                    Left 21 out of 50
                                                </span>
                                                <button className="bonusProductClaimBtn">Claim</button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                    {
                                        record.shipping_type == "2" ?
                                            <>
                                                <h6 className="m-0 mt-3 ff-poppins-semiBold fs-14 "> Delivery Staff </h6>
                                                <div className="bookForHeadDivRP ">
                                                    {record.delivery_staff_status == true ? (
                                                        <div className="staffCardHead rounded-4">
                                                            <div className="col-3">
                                                                <div className="staffProfileDiv">
                                                                    {
                                                                        record?.delivery_staff_detail?.delivery_staff_type == "Flyer" ?
                                                                            <img src={record?.delivery_staff_detail == "" ? defaultperson : record?.delivery_staff_detail?.pingledel_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                                                            :
                                                                            record?.delivery_staff_detail?.delivery_staff_type == "Pilot" ?
                                                                                <img src={record?.delivery_staff_detail?.pilot_image == "" ? defaultperson : record?.delivery_staff_detail?.pilot_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                                                                :
                                                                                <img src={record?.delivery_staff_detail?.staff_image == "" ? defaultperson : record?.delivery_staff_detail?.staff_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="col-9 staffContentHeadDiv">
                                                                <p className="staffNameStaff m-0">{record?.delivery_staff_detail?.delivery_staff_type == "Flyer" ? record?.delivery_staff_detail?.name : record?.delivery_staff_detail?.delivery_staff_type == "Pilot" ? record?.delivery_staff_detail?.pilot_name : record?.delivery_staff_detail?.staff_name}</p>
                                                                <p className="ff-poppins-regular fs-12 m-0"> {record?.delivery_staff_detail?.delivery_staff_type == "Flyer" ? record?.delivery_staff_detail?.phone_number : record?.delivery_staff_detail?.delivery_staff_type == "Pilot" ? record?.delivery_staff_detail?.phone_number : record?.delivery_staff_detail?.staff_designation}</p>

                                                                <div>
                                                                    {showStaffDetails ? (
                                                                        <div className="staffAboutDiv">
                                                                            <p className="staffSpecializationText fs-12 m-0 ff-poppins-regular">
                                                                                {record?.delivery_staff_detail?.staff_specialist}
                                                                            </p>
                                                                            <hr className="staffHr" />
                                                                            {/* <button className="petBehaviorRP">FRIENDLY</button> */}
                                                                            <p className="staffAboutStaff fs-12 ff-poppins-regular addersClamped-text"> {
                                                                                record?.delivery_staff_detail?.delivery_staff_type == "Flyer" ? record?.delivery_staff_detail?.about :
                                                                                    record?.delivery_staff_detail?.delivery_staff_type == "Pilot" ? record?.delivery_staff_detail?.about :
                                                                                        record?.delivery_staff_detail?.staff_about} </p>
                                                                            <div className="moreInfoDiv" onClick={toggleStaffDetails} >
                                                                                <p className="moreInfoText p-0 m-0 ff-poppins-semiBold">
                                                                                    Less info
                                                                                </p>
                                                                                <IoIosArrowDropupCircle className="" />
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="moreInfoDiv " onClick={toggleStaffDetails}  >
                                                                            <p className="moreInfoText p-0 m-0 ff-poppins-semiBold">
                                                                                More info
                                                                            </p>
                                                                            <IoIosArrowDropdownCircle />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className=" ff-poppins-semiBold staffCardHead fs-13 d-flex justify-content-center border border-2 rounded-3">
                                                            <p className="align-self-center mt-3"> Staff not assign  </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </> : <></>
                                    }

                                    <h6 className="ff-poppins-semiBold fs-14 mt-2 "> From Hub </h6>

                                    <div className=" SPCard">
                                        <div className="d-flex">
                                            <div className="col-3"  >
                                                <div className="primary-bg-light rounded-3 d-flex justify-content-center align-items-center"
                                                    style={{ height: "70px", width: "81px" }}>
                                                    <span className="fs-24 primary-text ff-poppins-medium">
                                                        H{record?.hub_name?.match(/\d+$/)?.[0]}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-6" >
                                                <div className="ms-2">
                                                    <p className="fs-14 p-0 m-0 ff-poppins-semiBold"> {record?.hub_name} </p>

                                                    <div className='ff-poppins-regular fs-11 m-0 secondary-text-1'>
                                                        {record?.vendor_company_name}
                                                    </div>
                                                    <div className="fs-10 mt-1 ff-poppins-SemiBold secondary-text-1">
                                                        <span className="primary-text ">  <IoLocationSharp /> </span>{record?.vendor_area}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-3 d-flex justify-content-center align-items-center  " onClick={() => navigate(`/history/${vendor.vendor_id}`)} >
                                                <span className="hubcardStoreIcons mb-1"></span>
                                                <div className="text-center ms-2">
                                                    <img src={store_icon} height="20" width="20" />
                                                    <p className="fs-11 ff-poppins-semiBold mt-1 primary-text">Go to store</p>
                                                </div>
                                            </div>
                                        </div>
                                        {record?.shipping_type == "1" &&
                                            (() => {
                                                const displayDistance =
                                                    typeof distance === "object" && distance?.text
                                                        ? distance.text
                                                        : typeof distance === "string" && distance
                                                            ? distance
                                                            : typeof record?.distance === "object" && record?.distance?.text
                                                                ? record.distance.text
                                                                : typeof record?.distance === "string" && record?.distance
                                                                    ? record.distance
                                                                    : typeof record?.delivery_address?.distance === "object" && record?.delivery_address?.distance?.text
                                                                        ? record.delivery_address.distance.text
                                                                        : typeof record?.delivery_address?.distance === "string" && record?.delivery_address?.distance
                                                                            ? record.delivery_address.distance
                                                                            : "";

                                                return (
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <div className="orderPassHubDistanceBox">
                                                            <span className="fs-14 ff-poppins-medium">{displayDistance}</span>
                                                        </div>
                                                        <div className="orderPassDirectionsBtn"
                                                            onClick={() => {
                                                                const lat = record?.hub_lat;
                                                                const lng = record?.hub_long;

                                                                if (lat && lng) {
                                                                    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
                                                                    window.open(url, "_blank");
                                                                }
                                                            }}
                                                        >
                                                            <FaLocationArrow size={14} className="text-white" />
                                                            <span>Directions</span>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                    </div>

                                    {/* <div>
                                    <div className="d-flex SPCard" >
                                        <div className="col-3" onClick={() => navigate(`/vendor/${vendor?.vendor_id}`)}>
                                            <img src={vendor?.vendor_logo} className="followerImage" alt="No Follower Profile" />
                                        </div>
                                        <div className="col-7" onClick={() => navigate(`/vendor/${vendor?.vendor_id}`)}>
                                            <div className="followerDetDiv">
                                                <div className="ff-poppins-semiBold fs-14 name_overflow" >{vendor?.vendor_company_name}</div>
                                                <div className="ff-poppins-medium fs-12 text-secondary">&#x2022; MID {vendor?.vendor_id} </div>
                                                <div className="ff-poppins-medium fs-12 text-secondary">&#x2022; {vendor?.vendor_type_name} </div>
                                                <div className="ff-poppins-medium fs-12 text-secondary singleline-text">&#x2022; {vendor?.vendor_address} </div>
                                            </div>
                                        </div>
                                        <div className="col-2 FollowerHistoryDiv" onClick={() => navigate(`/history/${vendor.vendor_id}`)} >
                                            <FaHourglassHalf className="hourClassIConFollower" />
                                            <p className="followerHistoryP">History</p>
                                        </div>
                                    </div>
                                </div> */}

                                    <div className="FHSIConsSP">
                                        <div className="d-flex align-items-center">
                                            <a href={`tel:${vendor?.vendor_mbl}`} className="text-decoration-none" >
                                                <div className="d-flex justify-content-center align-items-center contactDetails">
                                                    <PiPhoneCallFill className="IconsFHSSP" />
                                                    <div className="ms-2 ff-poppins-semiBold fs-14 text-white">
                                                        Call
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="hourGlassIconSP">
                                            <div className="d-flex align-items-center" onClick={() => navigate(`/chat/booking/${order_id}`, { state: { chatFlow: 'order' } })}  >
                                                <BiMessageDetail className="IconsFHSSP" />
                                                <p className="m-0 ms-2 fw-bold">Text</p>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex align-items-center " onClick={() => copyToClipboard()} >
                                                <RiShareFill className="IconsFHSSP" />
                                                <p className="m-0 ms-2 fw-bold">Share</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mt-3 h-100 cursor-pointer" >
                                            <span className="bookInfoTextRP ff-poppins-semiBold d-flex fs-15 mb-0"> Billing Information </span>
                                            <span  > <DownLossdbillingPDF data={record} /></span>
                                        </div>

                                        <p className="ff-poppins-regular p-0 m-0 mt-1 fs-12">
                                            Booking initiated at{" "}  {record.order_date_string ? record.order_date_string : formattedDate}
                                        </p>

                                        <span className="p-0 m-0 fs-14 ff-poppins-semiBold primary-text mt-3">{record?.order_type == 1 ? 'Tickets' : 'Membership'} </span>
                                        <div className="d-flex justify-content-between fs-14 mt-1 mb-2">
                                            <p className="m-0 fs-12 ff-poppins-regular"> {record?.ticket?.ticket_name}</p>
                                            <p className="m-0 fs-12 ff-poppins-regular"> {record?.quantity || record?.qty || record?.ticket_quantity || 1} x {record?.order_type == 2 ? (record?.ticket?.discount_status == 1 ? record?.ticket?.discount : record?.ticket?.ticket_price) : (record?.ticket_price ?? record?.ticket?.ticket_price)} </p>
                                        </div>
                                        {record?.order_type == 2 && record?.ticket?.validity_count_days && (
                                            <div className="price fs-12 ff-poppins-medium mb-2">
                                                (<span className="rupeeIcon ">₹</span>{record?.ticket?.ticket_price} / {record?.ticket?.validity_count_days}
                                                {record?.ticket?.membership_validity_type == 0 ? ' Days' : ' Month'})
                                            </div>
                                        )}

                                        {record?.order_type == 2 ?
                                            <div className="border-top-Dashed ff-poppins-regular fs-13">
                                                <div className="d-flex justify-content-between mt-2">
                                                    <p className="m-0 fs-12 ff-poppins-regular">Subtotal</p>
                                                    <p className="m-0 fs-12 ff-poppins-regular">
                                                        {data?.sub_total}
                                                    </p>
                                                </div>

                                                {data?.carrier_selected == 1 && (
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular">Carrier Charge</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {data?.carrier_booking_charge}
                                                        </p>
                                                    </div>
                                                )}

                                                {Number(data?.delivery_charges || record?.delivery_charges) > 0 && (
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular">Delivery Charge</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {data?.delivery_charges}
                                                        </p>
                                                    </div>
                                                )}

                                                {data?.packing_charges !== undefined &&
                                                    data?.packing_charges !== "" && (
                                                        <div className="d-flex justify-content-between">
                                                            <p className="m-0 fs-12 ff-poppins-regular">Packing Cost</p>
                                                            <p className="m-0 fs-12 ff-poppins-regular">
                                                                {data?.packing_charges}
                                                            </p>
                                                        </div>
                                                    )}

                                                <div className="d-flex justify-content-between">
                                                    <p className="m-0 fs-12 ff-poppins-regular"> Platform Charge</p>
                                                    <p className="m-0 fs-12 ff-poppins-regular">
                                                        {data?.user_platform_charges}
                                                    </p>
                                                </div>

                                                {
                                                    Number(record.delivery_tip) > 0 &&
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular">Delivery Tip</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.delivery_tip}
                                                        </p>
                                                    </div>
                                                }

                                                {/* {record.gst_status == 1 && (
                                                <div>
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular"> SGST</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.sgst_amount}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular"> CGST </p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.cgst_amount}
                                                        </p>
                                                    </div>
                                                </div>
                                            )} */}
                                            </div>
                                            :
                                            <div className="border-top-Dashed ff-poppins-regular fs-13">
                                                <div className="d-flex justify-content-between mt-2">
                                                    <p className="m-0 fs-12 ff-poppins-regular">Subtotal</p>
                                                    <p className="m-0 fs-12 ff-poppins-regular">
                                                        {record.sub_total}
                                                    </p>
                                                </div>

                                                {record.delivery_charge_status == true ?
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular"> Delivery Charge</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.delivery_charge}
                                                        </p>
                                                    </div>
                                                    : ""
                                                }

                                                {
                                                    record.packing_charges &&
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular">Packing Cost</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.packing_charges ? record.packing_charges : ""}
                                                        </p>
                                                    </div>
                                                }
                                                <div className="d-flex justify-content-between">
                                                    <p className="m-0 fs-12 ff-poppins-regular"> Platform Charge</p>
                                                    <p className="m-0 fs-12 ff-poppins-regular">
                                                        {record.user_platform_charges}
                                                    </p>
                                                </div>

                                                {
                                                    Number(record.delivery_tip) > 0 &&
                                                    <div className="d-flex justify-content-between">
                                                        <p className="m-0 fs-12 ff-poppins-regular">Delivery Tip</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular">
                                                            {record.delivery_tip}
                                                        </p>
                                                    </div>
                                                }

                                                {record.gst_status == true || record.gst_status == 1 && (
                                                    <div>
                                                        <div className="d-flex justify-content-between">
                                                            <p className="m-0 fs-12 ff-poppins-regular"> SGST</p>
                                                            <p className="m-0 fs-12 ff-poppins-regular">
                                                                {record.sgst_amount}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <p className="m-0 fs-12 ff-poppins-regular"> CGST </p>
                                                            <p className="m-0 fs-12 ff-poppins-regular">
                                                                {record.cgst_amount}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>}


                                        <div className="ff-poppins-bold mt-2 fs-14 border-top-Dashed">
                                            <div className="d-flex align-items-center w-100 justify-content-between mt-2">

                                                <div className=" ">Total </div>

                                                <div className=" d-flex align-items-center">
                                                    <span className="paid_badge">
                                                        {record?.payment_method == 5 ? (
                                                            'PAID BY WALLET'
                                                        ) : (
                                                            'PAID'
                                                        )}
                                                    </span><br />
                                                    <span className="fs-12 ms-2">
                                                        ₹{record?.total_amount || data?.total_amount}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {record.order_status == 3 ? (
                                            <div>
                                                <h6 className="m-0 ff-poppins-semiBold fs-14">
                                                    Cancel Information
                                                </h6>
                                                <p className="fs-12 m-0 p-0 ff-poppins-regular">{cancelorder.cancel_description} </p>
                                                <h6 className="m-0 ff-poppins-semiBold fs-14 mt-1">Refund Information</h6>
                                                <p className="fs-12 m-0 p-0 ff-poppins-regular">{cancelorder.refund_description} </p>
                                                {cancelorder.refund_status == "1" ? (
                                                    <div className="mt-1">
                                                        <h6 className="m-0 ff-poppins-semiBold fs-14">Refund Status</h6>
                                                        <p className="fs-12 m-0 p-0 ff-poppins-regular">
                                                            {cancelorder.refund_process_status == "1" ? (
                                                                "Refund Processing"
                                                            ) : cancelorder.refund_process_status == "2" ? (
                                                                "Refund Complete"
                                                            ) : cancelorder.refund_process_status == "3" ? (
                                                                "Refund Faild"
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                        {record.dispute == true ?
                                            <div>
                                                <div>
                                                    <h5 className="fs-15 ff-poppins-bold m-0">Dispute Status</h5>
                                                    <p className="secondary-text-1 fs-13 ">{record.dispute_detail?.dispute_status_name} </p>
                                                </div>
                                                <div>
                                                    <h5 className="fs-15 ff-poppins-bold m-0">Dispute description</h5>
                                                    <p className="secondary-text-1 fs-13">{record.dispute_detail?.dispute_description} </p>
                                                </div>
                                                <div>
                                                    <h5 className="fs-15 ff-poppins-bold m-0">Dispute reason</h5>
                                                    <p className="secondary-text-1 fs-13">{record.dispute_detail?.dispute_reason} </p>
                                                </div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                            </div>{" "}


                            {record.order_status == 1 && record.delivery_status <= 4 ? (
                                <>

                                    <div className=" rounded-3 bg-white d-flex justify-content-between align-items-center mt-3 p-2" onClick={() => getrefund()}>
                                        <button className="border border-0 fs-14 bg-white secondary-text-2 ff-poppins-semiBold" >
                                            Cancel
                                        </button>
                                        <IoIosArrowForward />
                                    </div>
                                    <a href="https://pingle.in/user/refund-policy.php" className="text-dark text-decoration-none fs-12 text-center ff-poppins-semiBold" target="_blank" rel="noopener noreferrer">
                                        <div className="text-center fs-10 mb-3 mt-2">
                                            Read our <span className="primary-text">Cancellation Policy</span> and <span className="primary-text">Refund Policy</span>
                                        </div>

                                    </a>
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                        {
                            record.dispute == true ?
                                <div>
                                    <p className="primary-text text-center fs-14 ff-poppins-semiBold mt-4">Raise Dispute</p>
                                </div> : <></>
                        }



                    </div>
                    :
                    <div className="p-3">

                        <div className="mb-3">
                            <Skeleton height={60} borderRadius={15} />
                            <div className="d-flex justify-content-center align-items-center mt-2" style={{ height: "180px" }}  >
                                <Skeleton width={250} height={190} borderRadius={10} />
                            </div>
                        </div>

                        <div className="mb-3">
                            <Skeleton height={60} borderRadius={15} />
                        </div>

                        <div className="mb-3">
                            <Skeleton width={180} height={20} />
                            <Skeleton height={60} borderRadius={15} />
                        </div>

                        <div className="mb-3">
                            <Skeleton width={150} height={20} className="mb-2" />
                            <Skeleton width={'100%'} height={80} borderRadius={12} />
                        </div>

                        {/* Product */}
                        <div className="mb-3">
                            <Skeleton width={120} height={20} className="mb-2" />
                            <div className="d-flex align-items-center p-2 border rounded">
                                <Skeleton width={70} height={70} borderRadius={10} />
                                <div className="ms-2 flex-grow-1">
                                    <Skeleton width={140} height={15} />
                                    <Skeleton width={100} height={12} />
                                    <Skeleton width={90} height={12} />
                                </div>
                            </div>
                        </div>

                        {/* Terms */}
                        <div className="mb-3">
                            <Skeleton width={160} height={20} className="mb-2" />
                            <Skeleton count={5} />
                        </div>

                        {/* Button */}
                        <Skeleton height={50} borderRadius={30} />
                    </div>
                }
                <div class="offcanvas mainModal CancelProduct cancelBtnModalProductPass"
                    style={{ position: "sticky !important", minHeight: "55px !important", borderTopLeftRadius: 15, borderTopRightRadius: 15 }} tabindex="-1" aria-labelledby="offcanvasBottomLabel" ref={cancelRefundModalRef} >
                    <div className="refundContentModal mb-2 refundModal">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="text-center">
                                <p className="m-0 ff-poppins-bold fs-14">Cancel Ticket</p>
                            </div>
                            <div className="modalCloseicon" onClick={() => { cancelRefundModalRef.current.classList.remove("show"); setIsModalOpen(false) }}>
                                <IoMdClose />
                            </div>
                        </div>
                        <p className="m-0 mt-1 fs-12 ff-poppins-regular" >
                            Are you sure you want to cancel the record.and get refund? Please
                            read the read the refund policy before clicking the 'confirm'
                            button.
                        </p>
                        <p className="mt-3 mb-2 ff-poppins-bold fs-14 "> Refund amount </p>
                        <p className="m-0 mb-2 ff-poppins-regular fs-12">{refund}</p>
                        <Link
                            to={"https://pingle.in/user/refund-policy.php"}
                            className="text-dark text-decoration-none fs-14 text-center"
                        >
                            <div className="text-center ff-poppins-regular fs-12">
                                Read our{" "}
                                <span className="primary-text"> Cancellation Policy </span> and{" "}
                                <span className="primary-text">Refund Policy</span>
                            </div>
                        </Link>
                    </div>
                    <button className="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold"
                        style={{ marginTop: 15, position: "relative", padding: "10px 20px", backgroundColor: "#primary-bg", color: "white", border: "0px", borderRadius: "5px", height: "40px", lineHeight: "20px", verticalAlign: "middle", }}
                        onClick={() => {
                            // if (!buttonClicked) {
                            cancel_order();
                            //   }
                        }}
                        disabled={buttonClicked}
                    >
                        {loading && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                }}
                            >
                                <Loading type="spinningBubbles" color="#fff" height={20} width={20} />
                            </div>
                        )}
                        {!loading && "Confirm"}
                    </button>

                </div>


                <div className={`modal fade`} id="exampleModalConfirm" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={cancelConfirmModalRef} style={{ backgroundColor: "#fff" }} >
                    <div className="modal-dialog modal-dialog-centered">
                        <div class="modal-content modal-success px-4 py-2" style={{ width: "70%" }}>
                            <div class="modal-body d-flex justify-content-center ff-poppins-bold">
                                Order Cancelled
                            </div>

                            <img src={AppointmentCancelled} alt="My Image" />

                            <div class="mb-4 d-flex text-center justify-content-center ff-poppins-regular">
                                The order has been cancelled successfully.
                            </div>
                            <button class="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold" onClick={() => navigate('/')}   >
                                OK{" "}
                            </button>
                        </div>
                    </div>
                </div>




                <div class="offcanvas" tabindex="-1" style={{ borderTopLeftRadius: 15, borderTopRightRadius: 15, width: 390 }} ref={canceldisputeModalRef}  >
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title ff-poppins-semiBold fs-16" id="offcanvasBottomLabel">Dispute reason</h5>
                        <button type="button" class="btn-close"></button>
                    </div>
                    <div class="offcanvas-body small">
                        <textarea className="w-100 rounded-2 p-2 mb-3" placeholder="please provide details of your dispute reason."
                            value={dispute}
                            onChange={(e) => setDispute(e.target.value)}>
                        </textarea>
                        <button className="w-100 primary-bg border-0 text-white ff-poppins-semiBold py-2 rounded" >Raise Dispute</button>
                    </div>
                </div>

            </div>

            <div class="modal fade" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1" ref={cancelOrderConfirmModalRef}    >
                <div class="modal-dialog modal-dialog-centered mainModal p-4">
                    <div class="modal-content p-3 text-center w-75">
                        <div class="">
                            <h1 class="d-flex ff-poppins-semiBold justify-content-center fs-14 mb-3" id="staticBackdropLabel"   >
                                Cancel Order
                            </h1>
                        </div>
                        <div class="">
                            <p className="m-0 fs-10 ff-poppins-regular text-center mb-3">
                                Are you sure want to cancel the order 100% refund ?
                            </p>
                        </div>
                        {
                            isLoading ?
                                <div className="d-flex justify-content-center">
                                    <div class="spinner-border mt-1 primary-text" role="status" style={{ height: "25px", width: "25px" }} >
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                :
                                <div className="d-flex justify-content-around">
                                    <button class="btn primary-bg rounded-pill fs-12 col-4 ff-poppins-regular text-white" onClick={() => cancel_order()} >
                                        Confirm
                                    </button>
                                    <button class="btn secondary-bg-1 text-dark fs-12 col-4 ff-poppins-regular rounded-pill" onClick={() => closecancelOrderModal()} >
                                        Cancel
                                    </button>
                                </div>
                        }

                    </div>
                </div>
            </div>

            {isModalOpen && <div className="modal-backdrop fade show"   ></div>}
        </div >
    );
};

export default Kitchen_OrderPass;







